
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AnalyticsService } from 'src/app/_services/analytics.service';
import { environment } from 'src/environments/environment';
 
type LangCode = 'en' | 'es' | 'de';
type Model = 'acad' | 'gen';
 
interface Piece {
  t?: string;
  id?: string;
  bad?: string;
  good?: string;
  type?: string;
  c?: string;
  skip?: boolean;
}
 
interface Seg {
  kind: 'plain' | 'issue' | 'done';
  text: string;
  id?: string;
  color?: string;
  selected?: boolean;
}
 
interface Card {
  id: string;
  type: string;
  bad: string;
  good: string;
  color: string;
  open: boolean;
}
 
interface LangBtn {
  code: LangCode;
  name: string;
  label: string;
  active: boolean;
}
 
const ACADEMIC: Piece[] = [
  { t: 'These ' }, { id: 'a0', bad: 'experiment', good: 'experiments', type: 'GRAMMAR', c: '#DC2626' },
  { t: ' were carried out ' }, { id: 'a1', bad: 'on', good: 'at', type: 'PREPOSITION', c: '#DC2626' },
  { t: ' room temperature using three ' }, { id: 'a2', bad: 'diffent', good: 'different', type: 'SPELLING', c: '#DC2626' },
  { t: ' substrates. Metacyclic ' }, { id: 'a3', bad: 'tripomastigotes', good: 'trypomastigotes', type: 'TECHNICAL SPELLING', c: '#7C3AED' },
  { t: ' were isolated from the rectal gland, and the algorithm was used for the calculation of parasite density. Females reported higher pain scores than males. The ' },
  { id: 'a4', bad: 'datas was', good: 'data were', type: 'GRAMMAR', c: '#DC2626' },
  { t: ' analysed using ' },
  { id: 'a5', bad: 'SPSS software version 26', good: 'SPSS (version 26)', type: 'ACADEMIC STYLE', c: '#7C3AED' },
  { t: '.' }
];
 
const GENERAL: Piece[] = [
  { t: 'Hi Priya,\n\nThanks for sending the proposal yesterday. I ' }, { id: 'g0', bad: 'has', good: 'have', type: 'GRAMMAR', c: '#DC2626' },
  { t: ' gone through it and the numbers ' }, { id: 'g1', bad: 'looks', good: 'look', type: 'GRAMMAR', c: '#DC2626' },
  { t: ' good, but could we ' }, { id: 'g2', bad: 'discuss about', good: 'discuss', type: 'WORD CHOICE', c: '#2563EB' },
  { t: ' the timeline before ' }, { id: 'g3', bad: 'friday', good: 'Friday', type: 'CAPITALIZATION', c: '#DC2626' },
  { t: '? Let me know what time ' }, { id: 'g4', bad: 'suit', good: 'suits', type: 'GRAMMAR', c: '#DC2626' },
  { t: ' you.\n\nRegards,\nArjun' }
];
 
const SPANISH: Piece[] = [
  { t: 'Ayer ' }, { id: 'e0', bad: 'fuí', good: 'fui', type: 'ORTOGRAFÍA', c: '#DC2626' },
  { t: ' ' }, { id: 'e1', bad: 'al biblioteca', good: 'a la biblioteca', type: 'GRAMÁTICA', c: '#DC2626' },
  { t: ' para terminar mi informe, pero ' }, { id: 'e2', bad: 'habían', good: 'había', type: 'GRAMÁTICA', c: '#DC2626' },
  { t: ' muchos estudiantes y no ' }, { id: 'e3', bad: 'pude concentrarme bién', good: 'pude concentrarme bien', type: 'ORTOGRAFÍA', c: '#DC2626' },
  { t: '. Mañana lo intentaré otra vez.' }
];
 
const GERMAN: Piece[] = [
  { t: 'Ich habe das Buch gestern ' }, { id: 'd0', bad: 'gelest', good: 'gelesen', type: 'GRAMMATIK', c: '#DC2626' },
  { t: ', aber ' }, { id: 'd1', bad: 'das Ende', good: 'das Ende', type: '', c: '', skip: true },
  { t: 'das Ende hat mich nicht überzeugt. ' }, { id: 'd2', bad: 'Das Mann', good: 'Der Mann', type: 'GRAMMATIK', c: '#DC2626' },
  { t: ' im Zug hat es mir empfohlen, ' }, { id: 'd3', bad: 'weil er', good: 'weil er', type: '', c: '', skip: true },
  { t: 'weil er es ' }, { id: 'd4', bad: 'interesant', good: 'interessant', type: 'RECHTSCHREIBUNG', c: '#DC2626' },
  { t: ' fand.' }
];
 
const LANGS: Array<[LangCode, string, string]> = [
  ['en', 'English', 'English (US)'],
  ['es', 'Español', 'Español'],
  ['de', 'Deutsch', 'Deutsch']
];
 

@Component({
  selector: 'app-gchero-section',
  templateUrl: './gchero-section.component.html',
  styleUrls: ['./gchero-section.component.scss']
})
export class GCHeroSectionComponent implements OnInit {
  trinkaCloudUrl = environment.trinkaCloudUrl;
  lang: LangCode = 'en';
  model: Model = 'acad';
  pw = false;
  glow = false;
  sel = '';
  acc: { [id: string]: boolean } = {};
  dis: { [id: string]: boolean } = {};
 
  langs: LangBtn[] = [];
  segs: Seg[] = [];
  cards: Card[] = [];
 
  isEn = true;
  langName = '';
  langLabel = '';
  countLabel = 'Suggestions';
  hasActive = false;
  showTeaser = false;
  allClear = false;
  teaser = '';
  powerWaiting = '';
  words = 0;
 
  private glowTimer: any;

  constructor(
    private analyticsService: AnalyticsService
  ) {
  }
 
  ngOnInit(): void {
    this.refresh();
  }
 
  ngOnDestroy(): void {
    clearTimeout(this.glowTimer);
  }
 
  trackByIndex(index: number): number {
    return index;
  }
 
  select(id: string): void {
    this.sel = id;
    this.refresh();
  }
 
  accept(id: string): void {
    this.acc = Object.assign({}, this.acc, { [id]: true });
    this.refresh();
  }
 
  dismiss(id: string): void {
    this.dis = Object.assign({}, this.dis, { [id]: true });
    this.refresh();
  }
 
  acceptAll(): void {
    const n = Object.assign({}, this.acc);
    this.activePieces().forEach((x) => { n[x.id as string] = true; });
    this.acc = n;
    this.refresh();
  }
 
  setModel(m: Model): void {
    this.model = m;
    this.sel = '';
    this.refresh();
  }
 
  setPower(on: boolean): void {
    this.pw = on;
    this.refresh();
  }
 
  pickLang(code: LangCode): void {
    this.lang = code;
    this.sel = '';
    this.refresh();
  }
 
  tryFree(): void {
    this.glow = true;
    clearTimeout(this.glowTimer);
    this.glowTimer = setTimeout(() => { this.glow = false; }, 1600);
  }
 
  private pieces(): Piece[] {
    const gen = this.model === 'gen';
    const src = this.lang === 'es' ? SPANISH : (this.lang === 'de' ? GERMAN : (gen ? GENERAL : ACADEMIC));
    return src.filter((x) => !x.skip);
  }
 
  private isLive(x: Piece): boolean {
    return x.id !== undefined && !this.acc[x.id] && !this.dis[x.id];
  }
 
  private activePieces(): Piece[] {
    return this.pieces().filter((x) => this.isLive(x));
  }
 
  private refresh(): void {
    const gen = this.model === 'gen';
    const P = this.pieces();
    const active = P.filter((x) => this.isLive(x));
    const sel = active.some((x) => x.id === this.sel) ? this.sel : (active[0] ? (active[0].id as string) : '');
    const powerN = this.lang !== 'en' ? 1 : (gen ? 2 : 3);
 
    this.segs = P.map((x): Seg => {
      if (x.id === undefined) { return { kind: 'plain', text: x.t as string }; }
      if (this.acc[x.id]) { return { kind: 'done', text: x.good as string }; }
      if (!this.isLive(x)) { return { kind: 'plain', text: x.bad as string }; }
      return { kind: 'issue', text: x.bad as string, id: x.id, color: x.c, selected: x.id === sel };
    });
 
    this.cards = active.map((x): Card => ({
      id: x.id as string,
      type: x.type as string,
      bad: x.bad as string,
      good: x.good as string,
      color: x.c as string,
      open: x.id === sel
    }));
 
    this.countLabel = active.length ? active.length + ' suggestion' + (active.length > 1 ? 's' : '') : 'Suggestions';
    this.hasActive = active.length > 1;
    this.showTeaser = active.length > 0 && this.lang === 'en';
    this.teaser = '+' + powerN + ' more in Power Mode';
    this.allClear = active.length === 0;
    this.powerWaiting = powerN + ' Power suggestions are waiting for this text.';
    this.words = this.lang === 'es' ? 30 : (this.lang === 'de' ? 24 : (gen ? 52 : 58));
 
    this.langs = LANGS.map((x): LangBtn => ({ code: x[0], name: x[1], label: x[2], active: this.lang === x[0] }));
    const cur = LANGS.find((x) => x[0] === this.lang) as [LangCode, string, string];
    this.langLabel = cur[2];
    this.langName = cur[1];
    this.isEn = this.lang === 'en';
  }

  trackGrammarCheckerClick() {
    this.analyticsService.trackEvent('grammar_checker_click', {
      event_category: 'CTA',
      event_label: 'Try for Free',
      page: 'grammar-checker'
    });
  }

}
